import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useInstagramIntegrationQuery = createQueryHook(
  ShopRendererApiClient.getInstagramIntegrationV2,
  {
    queryKey: ['instagramFeedIntegration'],
  },
)
